import { LAYOUT_BO } from "@/constants";
import { LazyLoadComponentWrapper } from "@/utils/lazy-load-component-wrapper";
import { ifAuthenticated } from "@/utils/auth";
import PassThrough from "@/views/pass-through";

const complainRouter = {
  path: "complain",
  component: PassThrough,
  beforeEnter: ifAuthenticated,
  meta: {
    layout: LAYOUT_BO,
    menuTitleTransCode: "COMPLAINT",
    menuIcon: "icon-route-complain",
    allowedRoles: ["ADMIN", "MANAGER", "OFFICER"]
  },
  children: [
    {
      path: "",
      component: () => LazyLoadComponentWrapper(import("@/views/bo/complain/list.vue")),
      meta: {
        layout: LAYOUT_BO,
        breadcrumbTransCodeList: ["COMPLAINT_MANAGEMENT"],
        allowedRoles: ["ADMIN", "MANAGER", "OFFICER"]
      },
    },
    {
      path: "detail/:id(\\d+)?",
      component: () => LazyLoadComponentWrapper(import("@/views/bo/complain/detail.vue")),
      meta: {
        layout: LAYOUT_BO,
        breadcrumbTransCodeList: ["COMPLAINT_MANAGEMENT", "COMPLAINT_MANAGEMENT_DETAIL"],
        allowedRoles: ["ADMIN", "MANAGER", "OFFICER"]
      },
    }
  ]
};

export default complainRouter;
